import { computed } from '@angular/core';
import {
    signalStore,
    withState,
    withComputed,
    withMethods,
    patchState,
} from '@ngrx/signals';
import { TourData } from '@app/shared/models/store-types';

// Re-export the type for backward compatibility
export type TourWithOrgSiteKey = TourData;

export interface ToursState {
    tours: TourData[];
    loading: boolean;
    error: string | null;
    lastUpdated: number;
}

const initialState: ToursState = {
    tours: [],
    loading: false,
    error: null,
    lastUpdated: 0,
};

export const ToursStore = signalStore(
    { providedIn: 'root' },
    withState<ToursState>(initialState),
    withComputed(({ tours }) => ({
        toursCount: computed(() => tours().length),
    })),
    withMethods(store => ({
        setToursLoading(loading: boolean): void {
            patchState(store, { loading });
        },
        setToursError(error: string | null): void {
            patchState(store, { error });
        },
        setTours(tours: TourData[]): void {
            patchState(store, { tours, lastUpdated: Date.now() });
        },
        addTour(tour: TourData): void {
            patchState(store, state => ({
                tours: [...state.tours, tour],
                lastUpdated: Date.now(),
            }));
        },
        updateTour(updatedTour: TourData): void {
            patchState(store, state => ({
                tours: state.tours.map(tour =>
                    tour._key === updatedTour._key ? updatedTour : tour
                ),
                lastUpdated: Date.now(),
            }));
        },
        removeTour(tourKey: string): void {
            patchState(store, state => ({
                tours: state.tours.filter(tour => tour._key !== tourKey),
                lastUpdated: Date.now(),
            }));
        },
        clearTours(): void {
            patchState(store, { tours: [], lastUpdated: Date.now() });
        },
    }))
);
